import {createSelector} from 'reselect';

import {Controller} from '@stubhub/react-store-provider';

const __RESERVED_GLOBAL_NAMESPACE__ = 'query';

const defaultsSelector = (queryState = {}) => queryState.defaults || {};

const querySelector = createSelector(
  (state = {}) => state.data || {},
  defaultsSelector,
  (query, defaults) => {
    delete query.__reset__; // Dont need this for component props

    return {...defaults, ...query};
  },
);

const controller = new Controller({
  namespace: __RESERVED_GLOBAL_NAMESPACE__,
  mapStateToProps(state) {
    return {
      query: querySelector(this.getLocalState(state)),
      queryDefaults: defaultsSelector(this.getLocalState(state)),
    };
  },
  reducers: ['QUERY:INIT', 'QUERY:SET', 'QUERY:ERROR'],
  actionCreators: {
    setDefaultQueryValues,
    updateQuery,
    replaceQuery,
  },
});

function setDefaultQueryValues(values) {
  return (dispatch) => {
    try {
      dispatch({
        type: 'QUERY:INIT',
        defaults: values,
      });
    } catch (e) {
      dispatch({
        type: 'QUERY:ERROR',
        error: e,
      });
    }
  };
}

function updateQuery({query}) {
  return (dispatch, getState) => {
    try {
      const currentUrlData = getState()[__RESERVED_GLOBAL_NAMESPACE__] || {};
      const {query: currentQuery} = currentUrlData;
      dispatch({
        type: 'QUERY:SET',
        data: {
          ...currentQuery,
          ...convertParams(query),
        },
      });
    } catch (e) {
      dispatch({
        type: 'QUERY:ERROR',
        error: e,
      });
    }
  };
}

function replaceQuery({query}) {
  return (dispatch) => {
    try {
      dispatch({
        type: 'QUERY:SET',
        data: convertParams(query),
      });
    } catch (e) {
      dispatch({
        type: 'QUERY:ERROR',
        error: e,
      });
    }
  };
}

const BOOL_REGEX = /(true|false)/i;
function convertParams(params) {
  const paramKeys = Object.keys(params);

  return paramKeys.reduce((result, paramKey) => {
    let paramValue = params[paramKey];
    if (typeof paramValue === 'string' && BOOL_REGEX.test(paramValue)) {
      result[paramKey] = paramValue.toLowerCase() === 'true';
    } else if (isNaN(paramValue)) {
      if (paramValue.indexOf(',') > 0) {
        paramValue = paramValue.split(',');
      }
      result[paramKey] = paramValue;
    } else {
      result[paramKey] = parseInt(paramValue, 10);
    }

    return result;
  }, {});
}

export default controller;
